import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class StopMeeting extends React.Component {
  render() {
    const { stopAll, stopCMMAMeeting } = this.props;
    return (
      <div className="stop-container">
        <div className="header">
          <FormattedMessage id="mc_label_stop_meeting" />
        </div>
        <div className="operate">
          <div className="btn" onClick={stopAll}>
            <FormattedMessage id="mc_btn_release" />
          </div>
          <div className="btn" onClick={stopCMMAMeeting}>
            <FormattedMessage id="mc_btn_hold" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StopMeeting.js